import React, {Component} from 'react';
import {connect} from 'react-redux';
import stringToColor from '../../../utils/stringToColor';
import LazyImg from '../../Helpers/LazyImg';
import { observer } from "mobx-react";

class UserBox extends Component {
  getLetter() {
    if(this.props.nick) {
      return this.props.nick.substr(0, 1);
    } else {
      return '';
    }
  }
  getAutoResize() {
    if(this.props.size * 2 > 100) {
      return "/autoresize/100x100xC";
    } else {
      const res=this.props.size*2;
      return `/autoresize/${res}x${res}xC`;
    }
  }
  render() {
    let style={};
    if(this.props.style) {
      style=this.props.style;
    }

    style.width=this.props.size;
    style.height=this.props.size;

    if(this.props.avatar) {
      return (
        <LazyImg src={`${this.getAutoResize()}${this.props.avatar}`} className={`db ${this.props.disable_rad?'':'rad4'} ${this.props.className}`} style={style}/>
      )
    } else {
      style.fontSize=this.props.size/2;
      style.background=stringToColor(this.props.nick);
      style.lineHeight=`${this.props.size}px`;
      return (
        <div className={`db tac ttu bold ${this.props.disable_rad?'':'rad4'}  w1 ${this.props.className}`} style={style}>
          {this.getLetter()}
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {}
}

export default observer(UserBox);
